import guide from '../data/michelinTaiwan2026.json';
import googleMapsService from './googleMapsService';

const LABELS = {
  THREE_STARS: ['米其林三星', 'Three MICHELIN Stars'],
  TWO_STARS: ['米其林二星', 'Two MICHELIN Stars'],
  ONE_STAR: ['米其林一星', 'One MICHELIN Star'],
  BIB_GOURMAND: ['必比登推介', 'Bib Gourmand'],
  SELECTED: ['米其林指南入選', 'MICHELIN Guide Selected']
};

const normalize = name => (name || '')
  .normalize('NFKC')
  .replace(/[（(][^）)]*[）)]/g, '')
  .toLocaleLowerCase()
  .replace(/[^\p{L}\p{N}]/gu, '');

export const findMichelinGuide = place => {
  const name = normalize(place?.name || place?.details?.name);
  const location = place?.geometry?.location || place?.details?.geometry?.location;
  if (!name || !location) return null;

  for (const [guideName, distinction, lat, lng, url] of guide) {
    const officialName = normalize(guideName);
    const sameName = name === officialName || (Math.min(name.length, officialName.length) >= 2 && (name.includes(officialName) || officialName.includes(name)));
    if (sameName && googleMapsService.calculateDistance({ lat, lng }, location) <= 750) {
      const [zh, en] = LABELS[distinction];
      return { distinction, zh, en, url };
    }
  }
  return null;
};
